import { render, staticRenderFns } from "./perfil-sociodemografico.vue?vue&type=template&id=86fcdff2&scoped=true&"
import script from "./perfil-sociodemografico.vue?vue&type=script&lang=js&"
export * from "./perfil-sociodemografico.vue?vue&type=script&lang=js&"
import style0 from "./perfil-sociodemografico.vue?vue&type=style&index=0&id=86fcdff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fcdff2",
  null
  
)

export default component.exports